import {AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {Router} from "@angular/router";
import {CoreService} from "~/app/core/core.service";

@Component({
    selector: "SideDrawerMenu",
    templateUrl: "./side-drawer-menu.component.html",
    styleUrls: ["./side-drawer-menu.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideDrawerMenuComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() activatedUrl: string;
    @Output() readonly close = new EventEmitter<any>();

    foundOffers: boolean;
    isAuthenticated: boolean;
    isTesting: boolean;
    isLogging: boolean;
    hasSponsor: boolean;
    needsValidation: boolean;
    userFullName: string;
    userEmail: string;
    userPhotoUrl: string;

    constructor(
        private readonly router: Router,
        private readonly core: CoreService,
    ) {
        // Use the component constructor to inject services.
        const settings = this.core.api.device_loadSettings();
        this.foundOffers = this.core.api.offers_haveOffers();
        this.isAuthenticated = this.core.api.user_isAuthenticated();
        this.isTesting = settings.testing && settings.testable;
        this.isLogging = settings.enableLogging && this.isTesting;
        this.needsValidation = this.core.api.user_needsValidation();
        this.userFullName = this.isAuthenticated ? `${this.core.api.user_info().firstName} ${this.core.api.user_info().lastName}` : "";
        this.userEmail = this.isAuthenticated ? this.core.api.user_info().email : "";
        this.userPhotoUrl = this.isAuthenticated ? this.core.api.user_info().photoUrl : "";
        this.hasSponsor = this.core.api.offers_isShowSponsorPage();
    }

    ngOnInit(): void {
        // do nothing
        this.activatedUrl = this.router.url;
    }

    ngAfterViewInit(): void {
        // do nothing
    }

    ngOnDestroy(): void {
        // do nothing
    }

    isComponentSelected(url: string): boolean {
        return this.activatedUrl.indexOf(url) > -1;
    }

    onNavItemTap(navItemRoute: string): void {
        // delay before running the navigation to give the side bar time to disappear
        setTimeout(() => {
            // offers, settings, about, login, validate
            if (navItemRoute.indexOf("offers") > 0) {
                this.core.nav.navPageSearching(this.core.api);
            } else if (navItemRoute.indexOf("sponsor") > 0) {
                this.core.nav.navPageSponsor(false);
            } else if (navItemRoute.indexOf("settings") > 0) {
                this.core.nav.navPageSettings();
            } else if (navItemRoute.indexOf("about") > 0) {
                this.core.nav.navPageAbout();
            } else if (navItemRoute.indexOf("location") > 0) {
                this.core.nav.navPageSearch(false);
            } else if (navItemRoute.indexOf("login") > 0) {
                this.core.nav.navPageLogin();
            } else if (navItemRoute.indexOf("register") > 0) {
                this.core.nav.navPageRegister();
            } else if (navItemRoute.indexOf("validate") > 0) {
                this.core.nav.navPageValidate(null, true);
            } else if (navItemRoute.indexOf("logs") > 0) {
                this.core.nav.navPageLogs();
            } else if (navItemRoute.indexOf("notifications-status") > 0) {
                this.core.nav.navPageNotificationsStatus(false);
            }
        }, 200);
        this.close.emit();
    }

    onLogoutTap(): void {
        this.core.dialogs.confirm({
            title: "Logout",
            message: "You are about log out of WhutsFree. Are you sure?",
            okButtonText: "Log Out",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result === true) {
                this.core.api.user_logout();
                // reset search results
                setTimeout(() => {
                    this.core.nav.navPageSearching(this.core.api);
                }, 200);
                this.close.emit();
            }
        });
    }
}
